module.exports = __webpack_public_path__ + "img/check.bba9f28c.svg";